export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9527.744bc96e.jpg";